import type { ApiMirrorRegistry } from '@fabric-app/types/connections';
import { IconConnectionPause, IconConnectionResume } from '@fabric-app/icons/svg';
import { DropdownMenu } from '@fabric-app/ui/components/DropdownMenu/DropdownMenu';
import { useMirrorRegistryToggleResumePause } from '../hooks/useMirrorRegistryToggleResumePause';
import { MirrorStatus } from '@fabric/woody-client';

export const DropdownGroupResumePauseMirrorRegistry: React.FC<{
  mirrorRegistry?: ApiMirrorRegistry;
}> = ({ mirrorRegistry }) => {
  const { toggleResumePause, status } = useMirrorRegistryToggleResumePause(mirrorRegistry);

  return toggleResumePause ? (
    <DropdownMenu.Group>
      <DropdownMenu.Item
        onClick={toggleResumePause}
        data-testid="folder-pause-connection"
        iconElement={
          status === MirrorStatus.ACTIVE ? <IconConnectionPause /> : <IconConnectionResume />
        }
      >
        {status === MirrorStatus.ACTIVE ? 'Pause' : 'Resume'} connection
      </DropdownMenu.Item>
    </DropdownMenu.Group>
  ) : null;
};
